module.exports = __webpack_public_path__ + "img/keine kamishirasawa_sc1.3364f4ad.png";